import { current, original, WritableDraft } from "immer";
import compact from "lodash/compact";
import { FilterV2Event } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_events";
import { FiltersV2StoreType } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { FilterV2 } from "PFTypes/filters_v2";

export const emitFiltersUpdate = (
  draftState: WritableDraft<FiltersV2StoreType>,
  updatedFilters: WritableDraft<FilterV2 | undefined>[]
) => {
  if (compact(updatedFilters).length === 0) {
    return;
  }

  draftState.eventsBus.emit(FilterV2Event.FiltersUpdate, {
    previousFilters: compact(compact(updatedFilters).map(original)),
    updatedFilters: compact(updatedFilters).map(current),
    updatedState: {
      mainFilters: current(draftState.mainFilters),
      childrenFilters: current(draftState.childrenFilters),
      areChildrenOn: draftState.areChildrenOn
    }
  });
};
